/** File is auto-generated by TypeWriter, a plug-in for Visual Studio. Modifications will be overridden when the template is rendered */


interface PasswordResetResponseDTO {
  email: string;
  code: string;
  password: string;
}
const PasswordResetResponseDTO = {
  create: (initValues?: Partial<PasswordResetResponseDTO> | null): PasswordResetResponseDTO => {
    const defaults: PasswordResetResponseDTO = {
      email: "",
      code: "",
      password: "",
    };
    const fixedValues: Partial<PasswordResetResponseDTO> = initValues != null
      ? {
      }
      : {};
    return { ...defaults, ...initValues, ...fixedValues };
  }
};

export default PasswordResetResponseDTO;
